var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 28.072,
    viewBox: "0 0 31.5 28.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f5f3b234542791cb702fc78f7ffb87d9",
    d: "M32.5,28.654a3.424,3.424,0,0,1-3.424,3.424H4.424A3.424,3.424,0,0,1,1,28.654V8.8A2.739,2.739,0,0,1,3.739,6.056H17.552L23.1,4.047a.678.678,0,0,1,.868.4l.584,1.606h2.471A2.739,2.739,0,0,1,29.761,8.8v1.37A2.739,2.739,0,0,1,32.5,12.9ZM3.739,7.426a1.37,1.37,0,0,0,0,2.739H6.228c.009,0,.014-.011.023-.014l7.52-2.725Zm19.912.124-.727-2h0l-1.4.509h0l-3.776,1.37h-.007l-7.559,2.739H24.6l-.95-2.615ZM28.391,8.8a1.37,1.37,0,0,0-1.37-1.37H25.048l1,2.739h2.348Zm1.37,2.739H3.739a2.708,2.708,0,0,1-1.37-.38v17.5a2.054,2.054,0,0,0,2.054,2.054H29.076a2.054,2.054,0,0,0,2.054-2.054V23.861H28.391a2.739,2.739,0,0,1,0-5.478H31.13V12.9A1.37,1.37,0,0,0,29.761,11.535Zm1.37,10.957V19.752H28.391a1.37,1.37,0,1,0,0,2.739Zm-2.739-2.054h1.37v1.37h-1.37Z",
    transform: "translate(-1 -4.006)",
    fill: "#7f7f7f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.7584ffa0906225f69334c49e43f9c1a2.svg";
export { ForwardRef as ReactComponent };